import React from 'react';
import { Box, IconButton } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { ListTable } from '../../../../../components/molecules/ListTable';
import PurchaseStatusBadge from '../../atoms/PurchaseStatusBadge';

interface PurchaseLead {
   _id: string;
   purchaseId?: string;
   quantity: number;
   unitPrice: number;
   status: 'NEW' | 'CONTACTED' | 'FOLLOW_UP' | 'CONVERTED' | 'LOST';
   source: string;
   createdAt: string;
   soldAmount?: number;
   user: {
     name: string;
     phoneNumber: string;
   };
   product: {
     name: string;
     brand: string;
     model: string;
     modelSeries?: string;
     indoorModelNo?: string;
     outdoorModelNo?: string;
     manufacturer?: string;
     type?: string;
     tonnage?: number;
     customerPrice?: number;
   };
 }

interface PurchaseTableProps {
  leads: PurchaseLead[];
  loading: boolean;
  onView: (id: string) => void;
}

const PurchaseTable: React.FC<PurchaseTableProps> = ({
  leads,
  loading,
  onView,
}) => {
   const headerPurchaseTable: [string, number][] = [
     ['Product ID', 160],
     ['User Name', 130],
     ['User Contact', 140],
     ['AC Type', 110],
     ['AC Model', 120],
     ['Brand', 120],
     ['Tonnage', 100],
     ['Retail Price', 120],
     ['Status', 100],
     ['Action', 100],
   ];

  return (
    <ListTable
      headerCells={headerPurchaseTable}
       rows={leads}
       isLoading={loading}
       noDataText="No purchase requests found"
       renderCell={(lead: PurchaseLead, colIndex: number) => {
         switch (colIndex) {
           case 0:
             return lead.purchaseId
               ? lead.purchaseId.substring(0, 10) + '...'
               : lead._id.substring(0, 10) + '...';

           case 1:
             return lead.user.name || 'Unknown';

           case 2:
             return lead.user.phoneNumber;

           case 3:
             return lead.product.type || 'N/A';

           case 4:
             return lead.product.modelSeries || '-';

           case 5:
             return lead.product.brand;

           case 6:
             return lead.product.tonnage ? `${lead.product.tonnage} Ton` : 'N/A';

           case 7:
             return `£ ${lead.unitPrice.toLocaleString()}`;

           case 8:
             return <PurchaseStatusBadge status={lead.status} />;

           case 9:
             return (
               <Box
                 sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}
               >
                 <IconButton
                   onClick={() => onView(lead._id)}
                   size="small"
                   sx={{ color: '#7B1FA2' }}
                 >
                   <VisibilityOutlinedIcon fontSize="small" />
                 </IconButton>
               </Box>
             );

           default:
             return null;
         }
       }}
     />
  );
};

export default PurchaseTable;
